module.exports = __webpack_public_path__ + "static/media/thumbnail.5d4c8f80.jpg";